import { Box, Stack, Typography } from "@mui/material";

import { QuotesOnlyShipmentProgressStepper } from "./QuotesOnlyShipmentProgressStepper";
import { ShipmentProgressStepper } from "./ShipmentProgressStepper";

interface Props {
  shipmentProgress: ShipmentProgress | null;
  shipment: ShipperCondensedShipment | undefined;
  error: string | null;
  shipmentProgressDetail: JSX.Element;
}

export function ShipmentProgress(props: Props) {
  const { shipmentProgress, shipment, error, shipmentProgressDetail } = props;
  if (error) {
    return (
      <Stack>
        {error != null && (
          <Typography color="red" align="center">
            {error}
          </Typography>
        )}
      </Stack>
    );
  }

  const isQuotesOnly = shipment?.info?.type === "QUOTES_ONLY";

  const stepperComponent = isQuotesOnly ? (
    <QuotesOnlyShipmentProgressStepper
      shipment={shipment}
      progress={shipmentProgress}
    />
  ) : (
    <ShipmentProgressStepper shipment={shipment} progress={shipmentProgress} />
  );

  return (
    <Box>
      <Box>
        <Stack direction="column" spacing={2} p={1}>
          {stepperComponent}
        </Stack>
      </Box>
      {shipmentProgressDetail}
    </Box>
  );
}
